import { I01EVAECSQUALI3_State } from '@batical/types/src'

const I01EVAECSQUALI3: I01EVAECSQUALI3_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_typeCalcul: 0,
  in_t11: 0.0,
  in_t21: 0.0,
  in_t31: 0.0,
  in_t32: 0.0,
  in_t41: 0.0,
  in_t42: 0.0,
  in_tempFroide: 10.0,
  in_tempBouclage: 55.0,
  in_tempStackage: 80.0,
  in_tempRetour: 30.0,
  in_volume: 0.0,
  res_totalLogementStandard: 0.0,
  res_s1: 0.0,
  res_s2: 0.0,
  res_s3: 0.0,
  res_simuDTU: 0.0,
  res_effEchangeur: 0.0,
  res_debitDTU: 0.0,
  res_puissMiniQualitel: 0.0,
  res_modePuissance: '',
  res_puissance: 0.0,
  mode: 'none',
  calcul_code: 'I01EVAECSQUALI3'
}

export default I01EVAECSQUALI3
